<template>
    <div class="box-ttl-wrap align-items-center" style="width: 100%">
        <ul class="pagination m-0">
            <li class="page-item page-pre" @click="goToPage(currentPage - 1)" :class="{ 'disabled': currentPage === 1 }">
                <a class="page-link" aria-label="previous page" href="javascript:void(0)">
                    <img src="/img/svg/icons-arrow-left.svg" alt="">
                </a>
            </li>

            <li v-for="page in visiblePages" :key="page" class="page-item" :class="{ 'active': currentPage === page }">
                <a class="page-link" :aria-label="'Page number ' + page" @click="goToPage(page)" href="javascript:void(0)">
                    {{ page }}
                </a>
            </li>

            <li class="page-item page-next" @click="goToPage(currentPage + 1)" :class="{ 'disabled': currentPage === lastPage }">
                <a class="page-link" aria-label="next page" href="javascript:void(0)">
                    <img src="/img/svg/icons-arrow-right.svg" alt="">
                </a>
            </li>
        </ul>

        <div class="d-flex align-items-center">
            <label for="" class="reg-label mr-2">Show:</label>
            <div class="form-group form-group-2 mb-0" style="min-width: unset; width:65px">
                <select v-model="itemsPerPage" @change="updateItemsPerPage" class="custom-select">
                    <option value="10">10</option>
                    <option value="20">20</option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Pagination',
    props: {
        currentPage: {
            type: Number,
            required: true,
        },
        lastPage: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            itemsPerPage: 10,
        };
    },
    computed: {
        visiblePages() {
            const range = 3;
            const start = Math.max(1, this.currentPage - range);
            const end = Math.min(this.lastPage, this.currentPage + range);

            const pages = [];
            for (let i = start; i <= end; i++) {
                pages.push(i);
            }

            return pages;
        },
    },
    methods: {
        goToPage(page) {
            if (page >= 1 && page <= this.lastPage && page !== this.currentPage) {
                this.$emit('changePage', page);
            }
        },
        updateItemsPerPage() {
            this.$emit('changeItemsPerPage', this.itemsPerPage);
        },
    },
};
</script>

<style scoped>
</style>
